<template>
  <v-layout
    row
    wrap
    mt-2
    align-center
    justify-center
  >
    <v-flex
      lg10
      xl10
      xs12
      md12
      sm12
    >
      <v-text-field
        v-model.lazy="inputSearchItem"
        filled
        prepend-inner-icon="mdi-magnify"
        :append-icon="!isSearchBtnActive ? 'mdi-arrow-right' : ''"
        class="stock-image-search-bar"
        clearable
        @click:append="searchStockImage()"
        @keyup.enter="searchStockImage()"
      >
        <template v-slot:label>
          <p class="custom-placeholder">
            {{ $t('message.bizgainOnboarding.searchStockImage') }}
          </p>
        </template>
      </v-text-field>
    </v-flex>
    <v-flex
      lg2
      xl2
      xs12
      md12
      sm12
      class="pt-0"
    >
      <v-btn
        color="primary"
        outline
        depressed
        :disabled="!this.inputSearchItem || !this.inputSearchItem.trim()"
        @click="searchStockImage()"
        :class="{
          'd-none': !isSearchBtnActive
        }"
      >
        {{ $t('message.bizgainOnboarding.search') }}
      </v-btn>
    </v-flex>
    <template>
      <v-flex
        lg12
        xs12
      >
        <v-alert
          color="info"
          icon="info"
          outline
          class="ma-0 mb-2"
          :value="this.isNoImageFound"
        >
          {{ $t('message.bizgainOnboarding.UnsplashImageNotFound') }}
        </v-alert>
        <v-alert
          color="error"
          icon="error"
          outline
          class="ma-0 mb-2"
          dismissible
          :value="this.isUnsplashError"
        >
          {{ $t('message.bizgainOnboarding.unsplashImageError') }}
        </v-alert>
      </v-flex>
      <v-flex
        xs12
        pa-0
        ma-0
      >
        <vue-perfect-scrollbar
          :settings="settings"
          ref="scroll"
        >
          <v-container
            grid-lg
            fluid
            pt-0
            :class="{'px-0': $vuetify.breakpoint.smAndDown, 'px-2': $vuetify.breakpoint.smAndUp}"
            class="
          scroll-area"
          >
            <v-layout
              row
              wrap
            >
              <v-flex
                lg2
                xs6
                md2
                sm4
                v-for="(image,index) in stockImages"
                :key="index"
                class="image-preview"
              >
                <v-layout
                  align-center
                  justify-center
                >
                  <business-image-card
                    @selectBusinessImage="selectImage"
                    :business-image="image"
                    :is-attribute="true"
                  />
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </vue-perfect-scrollbar>
      </v-flex>
    </template>
    <v-flex xs12 v-if="!this.isNoImageFound && this.isSearchApplied">
      <v-layout
        align-center
        justify-center
      >
        <v-progress-circular size="30" indeterminate color="primary" />
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
import BusinessImageCard from '../components/BusinessImageCard';
import { ApiService } from 'Features/bizgainOnboarding/services/apiService';
import { businessImageType } from 'Features/bizgainOnboarding/constants';
const { getUnsplashImages } = new ApiService();
import {
  VLayout,
  VFlex,
  VTextField,
  VAlert,
  VProgressCircular,
  VContainer
} from 'vuetify/lib';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
export default {
  data() {
    return {
      settings: {
        maxScrollbarLength: 30,
        suppressScrollX: true
      },
      inputSearchItem: null,
      lastSelectedItem: null,
      stockImages: [],
      isNoImageFound: true,
      isSearchApplied: false,
      pageNumber: 1,
      pageSize: 36,
      endOfImages: false,
      enableLoadMoreImages: false,
      isUnsplashError: false,
      imagesLoaded: true,
      isPresetImageSet: false
    }
  },
  props: {
    height: {
      type: Number,
      require: false,
      default: 150
    },
    width: {
      type: Number,
      require: false,
      default: 150
    },
    isDimension: {
      type: Boolean,
      default: true
    },
    presetSearchItem: {
      type: String,
      default: null
    },
    businessCategory: {
      type: String,
      default: null
    },
    isStockImageActive: {
      type: Boolean,
      default: true
    }
  },
  mounted(){
    if(this.presetSearchItem){
      this.isPresetImageSet = true;
      this.searchStockImage(this.presetSearchItem);
    }
    else{
      this.searchStockImage(this.businessCategory);
    }
  },
  computed: {
    isSearchBtnActive () {
      switch (this.$vuetify.breakpoint.name) {
        case 'lg': return true
        case 'xl': return true
        default: return false;
      }
    }
  },
  methods: {
    selectImage(img){
      this.$emit('selectImage', img);
    },
    async searchStockImage(searchItem, pageNumber = 1, loadMoreImages = false) {
      var fetchedImages = [];
      if(this.isStockImageActive && !this.inputSearchItem && !searchItem){
        return null;
      }
      if(!searchItem && !this.inputSearchItem && !this.presetSearchItem){
        return null;
      }
      else if(!searchItem && this.inputSearchItem){
        searchItem = this.inputSearchItem;
      }
      else if(!searchItem && this.presetSearchItem){
        searchItem = this.lastSelectedItem ? this.lastSelectedItem : this.presetSearchItem;
      }

      this.$refs.scroll.$el.scrollTop = 0;
      this.searchItem = searchItem;
      this.isSearchApplied = true;
      this.isUnsplashError = false;
      this.isNoImageFound = false;
      this.endOfImages = false;
      this.imagesLoaded = false;

      var payload = {
        keywords: searchItem,
        pageNumber: pageNumber,
        pageSize: this.pageSize
      };
      try{
        var response = await getUnsplashImages(payload);
      }
      catch{
        this.isSearchApplied = false;
        this.isUnsplashError = true;
        return null;
      }
      await response.forEachAsync(async image => {
        try {
          var unsplashImage = {
            name: image.imageName,
            url: image.imageUrl,
            source: image.imageSource,
            downloadLink: image.downloadLink,
            photographerName: image.photographer,
            photographerLink: image.PhotographerLink,
            dimension: {
              width: image.dimensions.split('x')[0],
              height: image.dimensions.split('x')[1]
            },
            selected: false,
            imageSource: businessImageType.StockImage
          };
        } catch{
          return;
        }
        fetchedImages.push(unsplashImage);
      });

      this.stockImages = fetchedImages;
      this.isNoImageFound = false;
      this.imagesLoaded = true;
      this.isSearchApplied = false;
      this.lastSelectedItem = searchItem;
      this.$emit('setPresetImage', this.lastSelectedItem);
      return this.stockImages;
    }
  },
  watch: {
    isPresetImageSet: {
      handler(value){
        if(value){
          this.inputSearchItem = this.presetSearchItem;
        }
      }
    }
  },
  components: {
    BusinessImageCard,
    VLayout,
    VFlex,
    VTextField,
    VAlert,
    VProgressCircular,
    VuePerfectScrollbar,
    VContainer
  }
}
</script>
<style scoped>
.stock-image-search-bar{
  color: var(--v-primary-base)
}
.custom-placeholder {
  font-size: 14px;
  overflow: hidden;
  max-width: 50ch;
  text-overflow: ellipsis;
  white-space: nowrap;
}
::v-deep .ps-container{
  height: 43vh;
  max-height: 43vh;
  width: 100%;
}

::v-deep .v-message{
  min-height: 0px !important;
}

.image-preview{
  position: relative;
}

.image-preview{
  position: relative;
}
</style>